
import Vue, { PropType } from 'vue'

import { ArticleFilterNameType, ArticleFilterType } from '@/models'

export default Vue.extend({
  name: 'ArticleFilter',
  props: {
    data: {
      type: Object as PropType<ArticleFilterType>,
      default: () => {}
    },
    query: {
      type: Object as PropType<{
        tag: string[]
        category: string[]
        type: string[]
        media: string[]
      }>,
      default: () => ({ tag: [], category: [], type: [], media: [] })
    }
  },
  data() {
    return {
      isExpand: false,
      height: 0
    }
  },
  computed: {
    isAll() {
      const { type, category, tag, media } = this.query
      return !(type.length || category.length || tag.length || media.length)
    }
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          this.getHeightListExpand()
        })
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getShowExpand()
      this.getHeightListExpand()
    })

    window.addEventListener('resize', () => {
      this.getHeightListExpand()
    })
  },
  methods: {
    selectAll() {
      this.selectFilter(null)
      this.close()
    },
    selectFilter(filter: string | null, filterName?: ArticleFilterNameType): void {
      this.$emit('onSelect', filter, filterName)
    },
    expand(): void {
      this.isExpand = !this.isExpand
    },
    close(): void {
      this.isExpand = false
    },
    getShowExpand(): void {
      const { tag, category, type, media } = this.$route.query

      const normalize = (val: unknown) =>
        typeof val === 'string'
          ? val
            .split(',')
            .map((v) => v.trim())
            .filter(Boolean)
          : []
      const allQueryValues = [
        ...normalize(tag),
        ...normalize(category),
        ...normalize(type),
        ...normalize(media)
      ]
      const allDataValues = [
        ...(this.data?.tags || []),
        ...(this.data?.types || []),
        ...(this.data?.category || []),
        ...(this.data?.media || [])
      ]

      this.isExpand =
        allQueryValues.length > 0 && allQueryValues.some((val) => allDataValues.includes(val))
    },
    getHeightListExpand(): void {
      const list = document.getElementById('filter')?.querySelector('#listExpand')
      this.height = list?.clientHeight || 0
    }
  }
})
